import parse from 'html-react-parser';
import type React from 'react';
import { useEffect, useRef } from 'react';
import type { TextData } from '../../../types/ChatWindow';
import { purifyAndLinkifyText } from '../messageHelper';

type IProps = { data: TextData };

const TextMessage: React.FC<IProps> = ({ data }) => {
  const { text } = data;
  const messageDisplay = purifyAndLinkifyText(text);
  const parsedText = parse(messageDisplay);
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const container = containerRef.current;

    if (!container) {
      return;
    }

    const handleClick = (event: MouseEvent) => {
      const summary = (event.target as Element).closest(
        'details.conversed-collapsible > summary',
      );

      if (!summary) {
        return;
      }

      const details = summary.closest(
        'details.conversed-collapsible',
      ) as HTMLDetailsElement;

      // * The toggle default action runs after click handlers, so defer the
      // * open check until after the browser has updated details.open.
      requestAnimationFrame(() => {
        if (details.open) {
          summary.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    };

    container.addEventListener('click', handleClick);

    return () => {
      container.removeEventListener('click', handleClick);
    };
  }, []);

  return (
    <div className='word-break-style' ref={containerRef}>
      {parsedText}
    </div>
  );
};

export default TextMessage;
